import { StoryblokComponent } from "@trydig/storyblok";
import { BlokWrap } from "~/components/bloks/BlokWrap";
import type { HeroSliderStoryblok } from "~/generated/sb/blok-types";
import styles from "./HeroSliderBlok.module.css";
import { Slider } from "./Slider";

export const HeroSliderBlok = ({
	blok,
	preview,
}: {
	blok: HeroSliderStoryblok;
	preview: boolean;
}) => {
	return (
		<BlokWrap asChild editable={blok}>
			<div className={styles.root} data-layout="blok">
				<div className={styles.aspectRatio__outer}>
					<div className={styles.aspectRatio__inner}>
						<Slider media={blok.slides}>
							{blok.slides.map((slide) => {
								return (
									<div className={styles.embla__slide} key={slide._uid}>
										<StoryblokComponent blok={slide} key={slide._uid} preview={preview} />
									</div>
								);
							})}
						</Slider>
					</div>
				</div>
			</div>
		</BlokWrap>
	);
};
